import { render, staticRenderFns } from "./PlaylistChooser.vue?vue&type=template&id=5a5473d8"
import script from "./PlaylistChooser.vue?vue&type=script&lang=js"
export * from "./PlaylistChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports